import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
  ChangeDetectorRef,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { TempMailService } from "../_services/tempmail.service";
import {
  ImageSettingsModel,
  RichTextEditorComponent,
  ToolbarSettingsModel,
} from "@syncfusion/ej2-angular-richtexteditor";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { EncryptionService } from "../_services/encryption.service";
import { Subject } from "rxjs";
import { AlertService } from "../_services/alert.service";
import { ExcelService } from "../_services/excel.service";
declare var RichTextEditor: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-email-service",
  templateUrl: "./email-service.component.html",
  styleUrls: ["email-service.component.css"],
})
export class EmailServiceComponent implements OnInit {
  currentAttachment1: {
    fileName: string;
    type: string;
    base64: string;
  } | null = null;

  currentAttachment2: {
    fileName: string;
    type: string;
    base64: string;
  } | null = null;

  currentAttachment3: {
    fileName: string;
    type: string;
    base64: string;
  } | null = null;

  currentAttachment4: {
    fileName: string;
    type: string;
    base64: string;
  } | null = null;

  @ViewChild("rteInstance", { static: false })
  rteInstance: RichTextEditorComponent;
  @ViewChild("sendMailSection", { static: false }) sendMailSection!: ElementRef;
  EditId: any;
  originalScheduleDatetime: string = "";
  templateId: any;
  isEditExcel: any;
  excelUrl: any;
  isErrorShow: any;
  isSuccessShow: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  menteeChecked = false;
  dtTrigger = new Subject();
  mentorChecked = false;
  partnerChecked = false;

  menteeToAll = false;
  mentorToAll = false;
  partnerToAll = false;

  recipients = [
    {
      name: "Mentee",
      mainToggle: false,
      toAllEnabled: false,
      toAllToggle: false,
    },
    {
      name: "Mentor",
      mainToggle: false,
      toAllEnabled: false,
      toAllToggle: false,
    },
    {
      name: "Partner",
      mainToggle: false,
      toAllEnabled: false,
      toAllToggle: false,
    },
  ];
  public imageSettings: ImageSettingsModel = {
    saveFormat: "Base64",
    allowedTypes: [".jpg", ".png", ".gif"],
    saveUrl: null,
  };

  toolbarSettings: any = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "FontName",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "|",
      "Formats",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Outdent",
      "Indent",
      "|",
      "CreateLink",
      "Image",
      "CreateTable",
      "|",
      "ClearFormat",
      "Print",
      "SourceCode",
      "FullScreen",
      "|",
      "Undo",
      "Redo",
      {
        tooltipText: "Insert Var",
        template: `<select id="variableDropdown" (change)="insertVariable($event.target.value)"  style="height:28px; padding:2px;">
<option value="">Insert Variable</option>
<option value="{{$name}}">Name</option>
</select>`,
      },
    ],
  };
  exl: boolean = false;
  modalReference: NgbActiveModal;
  modalTitle: string;
  isTestMode: boolean = false;
  showloding = false;
  lodingImage = false;
  TempMailForm: any;
  isSubmitted = false;
  isTestEmailSubmitted = false;
  value: string = "";
  templates: any = [];
  TestEmailForm: any;
  roles = ["mentee", "mentor", "partner"];
  emailServiceTotal: any;
  emailServiceListing: any = [];
  selectedFile: File;
  selectedFileName: any;
  exportEmailerList: any = [];
  fieldsToIncludeExcel: any = [];
  fileSizeError1 = false;
  fileSizeError2 = false;
  fileSizeError3 = false;
  fileSizeError4 = false;
  isEditMode = false;
  hasExistingAttachment = false;
  existingAttachmentName = "";
  start: number = 0;
  pageLength: number = 10;

  variables: { label: string; value: string }[] = [
    { label: "First Name", value: "{{firstName}}" },
    { label: "Last Name", value: "{{lastName}}" },
    { label: "Email", value: "{{email}}" },
    { label: "Mobile", value: "{{mobile}}" },
  ];

  constructor(
    public router: Router,
    private service: TempMailService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private excelService: ExcelService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
    private ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.TempMailForm = this.fb.group(
      {
        title: ["", [Validators.required]],
        subject: ["", Validators.required],
        body: ["", Validators.required],
        templates: [""],
        schedule_type: ["now"],
        schedule_date: [""],
        schedule_time: [""],
        mentee_type: [false],
        mentor_type: [false],
        partner_type: [false],
        mentee_to_all: [{ value: false, disabled: true }],
        mentor_to_all: [{ value: false, disabled: true }],
        partner_to_all: [{ value: false, disabled: true }],
        isTestEmailMode: [false],
        mentee_business_type: ["ALL"],
        specificEmails: ["", [this.multipleEmailValidator]],
        test_email: ["", [this.multipleEmailValidator]],
        is_excel: ["N"],
        is_attachment: ["N"],
        is_published: [false],
        attachment_delete_1: [false],
        attachment_delete_2: [false],
        attachment_delete_3: [false],
        attachment_delete_4: [false],
      },
      {
        validators: [
          this.recipientValidator,
          this.attachmentRequiredValidator.bind(this),
        ],
      },
    );
this.TempMailForm.get('is_attachment').valueChanges.subscribe(() => {
    this.validateAttachments();
  });

  ['attachment_delete_1','attachment_delete_2','attachment_delete_3','attachment_delete_4']
    .forEach(flag => {
      this.TempMailForm.get(flag).valueChanges.subscribe(() => {
        this.validateAttachments();
      });
    });

    this.TempMailForm.get("isTestEmailMode").valueChanges.subscribe((val) => {
      if (val) {
        this.TempMailForm.get("test_email").setValidators([
          Validators.required,
          this.multipleEmailValidator,
        ]);
        this.TempMailForm.get("specificEmails").clearValidators();
        this.TempMailForm.get("schedule_date").clearValidators();
        this.TempMailForm.get("schedule_time").clearValidators();
        this.TempMailForm.get("mentee_type").clearValidators();
        this.TempMailForm.get("mentor_type").clearValidators();
        this.TempMailForm.get("partner_type").clearValidators();
      } else {
        this.TempMailForm.get("test_email").clearValidators();
        this.TempMailForm.get("specificEmails").setValidators([
          this.multipleEmailValidator,
        ]);
        if (this.TempMailForm.get("schedule_type").value === "schedule") {
          this.TempMailForm.get("schedule_date").setValidators([
            Validators.required,
          ]);
          this.TempMailForm.get("schedule_time").setValidators([
            Validators.required,
          ]);
        }
      }
      this.TempMailForm.get("test_email").updateValueAndValidity();
      this.TempMailForm.get("specificEmails").updateValueAndValidity();
      this.TempMailForm.get("schedule_date").updateValueAndValidity();
      this.TempMailForm.get("schedule_time").updateValueAndValidity();
      this.TempMailForm.get("mentee_type").updateValueAndValidity();
      this.TempMailForm.get("mentor_type").updateValueAndValidity();
      this.TempMailForm.get("partner_type").updateValueAndValidity();
    });

    this.TempMailForm.get("schedule_type").valueChanges.subscribe((value) => {
      const scheduleDateControl = this.TempMailForm.get("schedule_date");
      const scheduleTimeControl = this.TempMailForm.get("schedule_time");

      if (
        value === "schedule" &&
        !this.TempMailForm.get("isTestEmailMode").value
      ) {
        scheduleDateControl.setValidators([Validators.required]);
        scheduleTimeControl.setValidators([Validators.required]);
      } else {
        scheduleDateControl.clearValidators();
        scheduleTimeControl.clearValidators();
      }
      scheduleDateControl.updateValueAndValidity();
      scheduleTimeControl.updateValueAndValidity();
    });

    this.TempMailForm.get("mentee_type").valueChanges.subscribe((value) => {
      if (value) {
        this.TempMailForm.get("mentee_to_all").enable();
      } else {
        this.TempMailForm.get("mentee_to_all").disable();
        this.TempMailForm.get("mentee_to_all").setValue(false);
      }
    });

    this.TempMailForm.get("mentor_type").valueChanges.subscribe((value) => {
      if (value) {
        this.TempMailForm.get("mentor_to_all").enable();
      } else {
        this.TempMailForm.get("mentor_to_all").disable();
        this.TempMailForm.get("mentor_to_all").setValue(false);
      }
    });

    this.TempMailForm.get("partner_type").valueChanges.subscribe((value) => {
      if (value) {
        this.TempMailForm.get("partner_to_all").enable();
      } else {
        this.TempMailForm.get("partner_to_all").disable();
        this.TempMailForm.get("partner_to_all").setValue(false);
      }
    });

    window.scroll(0, 0);
    this.loadHide();
    this.getEmailServiceListing();
    this.getTemplateMaster();
  }


    getRowNumber(index: number): number {
    return this.start + index + 1;
  }
  onAttachmentSelected1(event: Event) {
    this.fileSizeError1 = false;

    const input = event.target as HTMLInputElement;
    if (!input.files.length) return;

    const file = input.files[0];
    const fileNameLower = file.name.toLowerCase();

    const allowedExtensions = [
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp",     // images
  ".mp4", ".mov", ".webm", ".ogg",                      // videos
  ".pdf",                                               // pdf
  ".doc", ".docx",                                      // word
  ".ppt", ".pptx",
    ];

    const isAllowedExtension = allowedExtensions.some((ext) =>
      fileNameLower.endsWith(ext),
    );

    if (!isAllowedExtension) {
      alert(
        "Invalid file type!\n\nAllowed: Images (.jpg, .png, etc.), Videos (.mp4, etc.), " +
          "PDF (.pdf), Word (.doc, .docx), Excel (.xls, .xlsx), Text (.txt)",
      );
      input.value = "";
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      this.fileSizeError1 = true;
      input.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result as string;

      if (!dataUrl || !dataUrl.startsWith("data:")) {
        alert("Error reading file. Please try again.");
        input.value = "";
        return;
      }

      this.currentAttachment1 = {
        fileName: file.name,
        type: file.type || this.getMimeTypeFromExtension(file.name),
        base64: dataUrl,
      };

      this.TempMailForm.patchValue({ attachment_delete_1: false });
      input.value = "";
    };

    reader.onerror = () => {
      alert("Error reading the file. Please try again.");
      input.value = "";
    };

    reader.readAsDataURL(file);
  }

  private getMimeTypeFromExtension(fileName: string): string {
    const ext = fileName.toLowerCase().split(".").pop() || "";

    const mimeMap: { [key: string]: string } = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      txt: "text/plain",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      mp4: "video/mp4",
      mov: "video/quicktime",
      // add more if needed
    };

    return mimeMap[ext] || "application/octet-stream";
  }

  onAttachmentSelected2(event: Event) {
    this.fileSizeError2 = false;

    const input = event.target as HTMLInputElement;
    if (!input.files.length) return;

    const file = input.files[0];
    const fileNameLower = file.name.toLowerCase();

    const allowedExtensions = [
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp",     // images
  ".mp4", ".mov", ".webm", ".ogg",                      // videos
  ".pdf",                                               // pdf
  ".doc", ".docx",                                      // word
  ".ppt", ".pptx",
    ];

    const isAllowedExtension = allowedExtensions.some((ext) =>
      fileNameLower.endsWith(ext),
    );

    if (!isAllowedExtension) {
      alert(
        "Invalid file type!\n\nAllowed: Images (.jpg, .png, etc.), Videos (.mp4, etc.), " +
          "PDF (.pdf), Word (.doc, .docx), Excel (.xls, .xlsx), Text (.txt)",
      );
      input.value = "";
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      this.fileSizeError2 = true;
      input.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result as string;

      if (!dataUrl || !dataUrl.startsWith("data:")) {
        alert("Error reading file. Please try again.");
        input.value = "";
        return;
      }

      this.currentAttachment2 = {
        fileName: file.name,
        type: file.type || this.getMimeTypeFromExtension(file.name), // fallback mime
        base64: dataUrl,
      };

      this.TempMailForm.patchValue({ attachment_delete_2: false });
      input.value = "";
    };

    reader.onerror = () => {
      alert("Error reading the file. Please try again.");
      input.value = "";
    };

    reader.readAsDataURL(file);
  }

  onAttachmentSelected3(event: Event) {
    this.fileSizeError3 = false;

    const input = event.target as HTMLInputElement;
    if (!input.files.length) return;

    const file = input.files[0];
    const fileNameLower = file.name.toLowerCase();

    const allowedExtensions = [
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp",     // images
  ".mp4", ".mov", ".webm", ".ogg",                      // videos
  ".pdf",                                               // pdf
  ".doc", ".docx",                                      // word
  ".ppt", ".pptx",
    ];

    const isAllowedExtension = allowedExtensions.some((ext) =>
      fileNameLower.endsWith(ext),
    );

    if (!isAllowedExtension) {
      alert(
        "Invalid file type!\n\nAllowed: Images (.jpg, .png, etc.), Videos (.mp4, etc.), " +
          "PDF (.pdf), Word (.doc, .docx), Excel (.xls, .xlsx), Text (.txt)",
      );
      input.value = "";
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      this.fileSizeError3 = true;
      input.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result as string;

      if (!dataUrl || !dataUrl.startsWith("data:")) {
        alert("Error reading file. Please try again.");
        input.value = "";
        return;
      }

      this.currentAttachment3 = {
        fileName: file.name,
        type: file.type || this.getMimeTypeFromExtension(file.name), // fallback mime
        base64: dataUrl,
      };

      this.TempMailForm.patchValue({ attachment_delete_3: false });
      input.value = "";
    };

    reader.onerror = () => {
      alert("Error reading the file. Please try again.");
      input.value = "";
    };

    reader.readAsDataURL(file);
  }

  onAttachmentSelected4(event: Event) {
    this.fileSizeError4 = false;

    const input = event.target as HTMLInputElement;
    if (!input.files.length) return;

    const file = input.files[0];
    const fileNameLower = file.name.toLowerCase();

    const allowedExtensions = [
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp",     // images
  ".mp4", ".mov", ".webm", ".ogg",                      // videos
  ".pdf",                                               // pdf
  ".doc", ".docx",                                      // word
  ".ppt", ".pptx",
    ];

    const isAllowedExtension = allowedExtensions.some((ext) =>
      fileNameLower.endsWith(ext),
    );

    if (!isAllowedExtension) {
      alert(
        "Invalid file type!\n\nAllowed: Images (.jpg, .png, etc.), Videos (.mp4, etc.), " +
          "PDF (.pdf), Word (.doc, .docx), Excel (.xls, .xlsx), Text (.txt)",
      );
      input.value = "";
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      this.fileSizeError4 = true;
      input.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const dataUrl = reader.result as string;

      if (!dataUrl || !dataUrl.startsWith("data:")) {
        alert("Error reading file. Please try again.");
        input.value = "";
        return;
      }

      this.currentAttachment4 = {
        fileName: file.name,
        type: file.type || this.getMimeTypeFromExtension(file.name), // fallback mime
        base64: dataUrl,
      };

      this.TempMailForm.patchValue({ attachment_delete_4: false });
      input.value = "";
    };

    reader.onerror = () => {
      alert("Error reading the file. Please try again.");
      input.value = "";
    };

    reader.readAsDataURL(file);
  }

getFileIconType(
  attachment: { fileName: string; type: string; base64: string } | null,
): string {
  if (!attachment) {
    return "file";
  }

  if (!attachment.base64 && this.isEditMode && this.hasExistingAttachment) {
    const type = (attachment.type || "").toLowerCase();

    if (type.startsWith("image/")) return "image";
    if (type.startsWith("video/")) return "video";
    if (type === "application/pdf") return "pdf";
    if (
      type === "application/msword" ||
      type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return "word";
    }
    if (
      type === "application/vnd.ms-powerpoint" ||
      type === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ) {
      return "powerpoint";  
    }
    return "file";
  }

  if (attachment.type) {
    const mime = attachment.type.toLowerCase();

    if (mime.startsWith("image/")) return "image";
    if (mime.startsWith("video/")) return "video";
    if (mime === "application/pdf") return "pdf";
    if (
      mime === "application/msword" ||
      mime === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      return "word";
    }
    if (
      mime === "application/vnd.ms-powerpoint" ||
      mime === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ) {
      return "powerpoint"; 
    }

    return "file";
  }
  return "file";
}
  // getFileIconType(
  //   attachment: { fileName: string; type: string; base64: string } | null,
  // ): string {
  //   if (!attachment) {
  //     return "file";
  //   }

  //   if (!attachment.base64 && this.isEditMode && this.hasExistingAttachment) {
  //     const type = (attachment.type || "").toLowerCase();

  //     if (type.startsWith("image/")) return "image";
  //     if (type.startsWith("video/")) return "video";
  //     if (type === "application/pdf") return "pdf";
  //     if (
  //       type === "application/msword" ||
  //       type ===
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  //     ) {
  //       return "word";
  //     }
  //     if (
  //       type === "application/vnd.ms-excel" ||
  //       type ===
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //     ) {
  //       return "excel";
  //     }
  //     if (type === "text/plain") return "text";

  //     return "file";
  //   }

  //   if (attachment.type) {
  //     const mime = attachment.type.toLowerCase();

  //     if (mime.startsWith("image/")) return "image";
  //     if (mime.startsWith("video/")) return "video";
  //     if (mime === "application/pdf") return "pdf";
  //     if (
  //       mime === "application/msword" ||
  //       mime ===
  //         "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  //     ) {
  //       return "word";
  //     }
  //     if (
  //       mime === "application/vnd.ms-excel" ||
  //       mime ===
  //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //     ) {
  //       return "excel";
  //     }
  //     if (mime === "text/plain") return "text";

  //     return "file";
  //   }

  //   return "file";
  // }

  removeAttachment1() {
    this.currentAttachment1.base64 = "";
    this.currentAttachment1.type = "";
    this.currentAttachment1.fileName = ""
    this.fileSizeError1 = false;
    this.TempMailForm.patchValue({ attachment_delete_1: true });

    this.cdr.detectChanges();
  }

  removeAttachment2() {
    this.currentAttachment2.base64 = "";
    this.currentAttachment2.type = "";
    this.currentAttachment2.fileName = ""
    this.fileSizeError2 = false;
    this.TempMailForm.patchValue({ attachment_delete_2: true });
  }

  removeAttachment3() {
    this.currentAttachment3.base64 = "";
    this.currentAttachment3.type = "";
    this.currentAttachment3.fileName = ""
    this.fileSizeError3 = false;
    this.TempMailForm.patchValue({ attachment_delete_3: true });
  }

  removeAttachment4() {
    this.currentAttachment4.base64 = "";
    this.currentAttachment4.type = "";
    this.currentAttachment4.fileName = ""
    this.fileSizeError4 = false;
    this.TempMailForm.patchValue({ attachment_delete_4: true });
  }

  onFileSelected(event): void {
    const file = event.target.files[0];
    if (file && file.name.endsWith(".csv")) {
      this.selectedFile = file;
      this.selectedFileName = file.name;

      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        const base64String = reader.result.toString().split(",")[1];
        this.excelUrl = `data:text/csv;base64,${base64String}`;
      };
    } else {
      console.error("Please select a CSV file");
    }
  }

  convertToBase64(): void {
    if (!this.selectedFile) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.selectedFile);
    reader.onload = () => {
      const base64String = reader.result.toString().split(",")[1];
      this.excelUrl = `data:text/csv;base64,${base64String}`;
    };
    reader.onerror = (error) => {
      console.error("Error occurred while reading the file:", error);
    };
  }

  insertVariable(variableName: string) {
    let insertion = "{{name}}";
    switch (variableName) {
      case "name":
        insertion = "{{name}}";
        break;
      case "currentDate":
        insertion = `{{${new Date().toLocaleDateString()}}}`;
        break;
      default:
        insertion = "{{name}}";
    }
    this.insertAtCursor(insertion);
  }

  private insertAtCursor(text: string) {
    let editor = document.querySelector(".e-richtexteditor") as any;
    let range = editor.ej2Instances.getSelection();
    editor.ej2Instances.insertText(text);
  }

  recipientValidator(form: FormGroup): ValidationErrors | null {
    const isTestMode = form.get("isTestEmailMode").value;

    if (isTestMode) {
      return null;
    }

    const menteeChecked = form.get("mentee_type").value;
    const mentorChecked = form.get("mentor_type").value;
    const partnerChecked = form.get("partner_type").value;
    const specificEmails = form.get("specificEmails").value;

    if (
      !menteeChecked &&
      !mentorChecked &&
      !partnerChecked &&
      !specificEmails
    ) {
      return {
        noRecipient: true,
        missingCheckboxes: true,
        missingSpecificEmails: true,
      };
    }
    return null;
  }

  onClickTestEmail() {
    this.isTestMode = true;
    (this.TempMailForm as any).isTestMode = true;

    this.TempMailForm.patchValue({ body: this.value });
    this.isSubmitted = true;
    this.loadShow();

    if (
      this.TempMailForm.get("title").valid &&
      this.TempMailForm.get("subject").valid &&
      this.value.trim() !== "" &&
      this.TempMailForm.get("specificEmails").valid
    ) {
      const formData: FormData = new FormData();
      formData.append("test_email", this.TestEmailForm.value.test_email || "");
      formData.append("subject", this.TempMailForm.value.subject);
      formData.append("body", this.TempMailForm.value.body);
      formData.append("title", this.TempMailForm.value.title);

      this.service.onTestEmail(formData).subscribe({
        next: (res: any) => {
          this.loadHide();
          this.isErrorShow = "Test Email has been sent successfully";
          setTimeout(() => (this.isErrorShow = ""), 5000);
        },
        error: (err) => {
          this.loadHide();
        },
      });
    } else {
      this.loadHide();
    }

    this.isTestMode = false;
    (this.TempMailForm as any).isTestMode = false;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();

      setTimeout(() => {
        this.onRteCreated();
      }, 500);
    });
  }

  onRteCreated(): void {
    setTimeout(() => {
      this.attachVariableDropdownListener();
    }, 2000);
  }

  private attachVariableDropdownListener(): void {
    const dropdown = $("#variableDropdown") as any;
    $("#variableDropdown").on("change", function (e) {
      var text = $(this).val();
      let $editor = $(".e-richtexteditor") as any;
      let editorInstance = $editor[0].ej2_instances[0];
      if (editorInstance) {
        editorInstance.executeCommand("insertText", text);
      }
    });
    if (!dropdown) {
      setTimeout(() => this.attachVariableDropdownListener(), 200);
      return;
    }
    dropdown.onchange = null;
    dropdown.onchange = (evt: Event) => {
      const val = (evt.target as HTMLSelectElement).value;
      if (!val) return;
      this.insertVariableAtCursor(val);

      this.ngZone.run(() => {
        let updated = "";
        try {
          updated =
            this.rteInstance && (this.rteInstance as any).getHtml
              ? (this.rteInstance as any).getHtml()
              : (this.rteInstance && (this.rteInstance as any).value) || "";
        } catch (e) {
          updated = (this.rteInstance && (this.rteInstance as any).value) || "";
        }
        this.TempMailForm.patchValue({ body: updated });
        this.cdr.detectChanges();
      });
      dropdown.value = "";
    };
  }
  formatDateTime(input: string): string {
    const date = new Date(input.replace(" ", "T"));

    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hStr = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hStr}:${minutes}:${seconds} ${ampm}`;
  }

  getEmailServiceListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      order: [[4, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/mass-email/list-mailer",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters)),
              ),
            },
            {},
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.emailServiceListing = resp["data"].map((item) => ({
              ...item,
              isRefreshing: false, 
            }));
            this.emailServiceTotal = resp["recordsTotal"];
            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: this.emailServiceListing, 
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "title" },
        { data: "subject" },
        { data: "template_name" },
        { data: "schedule_date" },
        { data: "schedule_by" },
        { data: "mentee_count" },
        { data: "mentor_count" },
        { data: "partner_count" },
        { data: "total_count" },
        { data: "pending_and_inprogress_count" },
        { data: "success_count" },
        { data: "invalid_email_and_error_count" },
        { data: "stopped_count" },
        { data: "excel_count" },
      ],
    };
  }

  onDuplicate(content, id) {
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
    this.selectedFileName = "";
    this.EditId = "";
    this.loadShow();
    const data = { id: id };
    this.service
      .onEditEmail(data)
      .pipe()
      .subscribe(
        (res) => {
          if (res && res["status"] === 200 && res["data"]) {
            const editData = res["data"];
            this.originalScheduleDatetime = editData.schedule_date || "";

            this.TempMailForm.patchValue({
              title: editData.title || "",
              subject: editData.subject || "",
              body: editData.body || "",
              is_published: editData.is_published == "DRAFT",
              mentee_business_type: editData.mentee_business_type || "ALL",
              templates: editData.template_id
                ? this.templates
                    .findIndex((t) => t.id === editData.template_id)
                    .toString()
                : "",
              specificEmails:
                editData.specific_emails && editData.specific_emails !== '[""]'
                  ? editData.specific_emails.replace(/[\[\]"]+/g, "")
                  : "",
              schedule_type: editData.schedule_type || "now",
              schedule_date: editData.schedule_date
                ? editData.schedule_date.split(" ")[0]
                : "",
              schedule_time: editData.schedule_date
                ? editData.schedule_date.split(" ")[1].substring(0, 5)
                : "", // HH:MM only
              mentee_type: editData.mentee_type !== "none",
              mentor_type: editData.mentor_type !== "none",
              partner_type: editData.partner_type !== "none",
              mentee_to_all: editData.mentee_type === "verified",
              mentor_to_all: editData.mentor_type === "verified",
              partner_to_all: editData.partner_type === "verified",
            });

            this.value = editData.body || "";
            if (this.rteInstance) {
              this.rteInstance.value = this.value;
            }

            this.templateId = editData.template_id || "";

            this.modalTitle = " Create Duplicate Email";
          }
          this.loadHide();
        },
        (error) => {
          this.loadHide();
        },
      );
  }

  onEdit(content, id) {
     this.isSuccessShow = "";
    this.isErrorShow = "";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
    this.selectedFileName = "";

    this.EditId = id;
    this.loadShow();
    const data = { id: id };
    this.service
      .onEditEmail(data)
      .pipe()
      .subscribe(
        (res) => {
          if (res && res["status"] === 200 && res["data"]) {
            const editData = res["data"];

            this.currentAttachment1 = {
              fileName: "",
              type: editData.attachment_type_1,
              base64: editData.attachment_path_1
                ? editData.attachment_path_1
                : "",
            };

            this.currentAttachment2 = {
              fileName: "",
              type: editData.attachment_type_2,
              base64: editData.attachment_path_2
                ? editData.attachment_path_2
                : "",
            };
            this.currentAttachment3 = {
              fileName: "",
              type: editData.attachment_type_3,
              base64: editData.attachment_path_3
                ? editData.attachment_path_3
                : "",
            };

            this.currentAttachment4 = {
              fileName: "",
              type: editData.attachment_type_4,
              base64: editData.attachment_path_4
                ? editData.attachment_path_4
                : "",
            };

            const att1 = !!editData.attachment_path_1;
            const att2 = !!editData.attachment_path_2;
            const att3 = !!editData.attachment_path_3;
            const att4 = !!editData.attachment_path_4;

            const hasAnyAttachment = att1 || att2 || att3 || att4;

            const isExcelValue = editData.excel_path ? "Y" : "N";
            this.isEditExcel = editData.excel_path;
            this.originalScheduleDatetime = editData.schedule_date || "";
            this.TempMailForm.patchValue({
              title: editData.title || "",
              subject: editData.subject || "",
              body: editData.body || "",
              is_published: editData.is_published == "DRAFT",
              mentee_business_type: editData.mentee_business_type || "ALL",
              templates: editData.template_id
                ? this.templates
                    .findIndex((t) => t.id === editData.template_id)
                    .toString()
                : "",
              specificEmails:
                editData.specific_emails && editData.specific_emails !== '[""]'
                  ? editData.specific_emails.replace(/[\[\]"]+/g, "")
                  : "",
              schedule_type: editData.schedule_type || "now",
              schedule_date: editData.schedule_date
                ? editData.schedule_date.split(" ")[0]
                : "",
              schedule_time: editData.schedule_date
                ? editData.schedule_date.split(" ")[1].substring(0, 5)
                : "",
              mentee_type: editData.mentee_type !== "none",
              mentor_type: editData.mentor_type !== "none",
              partner_type: editData.partner_type !== "none",
              mentee_to_all: editData.mentee_type === "verified",
              mentor_to_all: editData.mentor_type === "verified",
              partner_to_all: editData.partner_type === "verified",
              is_excel: isExcelValue,
              is_attachment1: "false",
              is_attachment2: "false",
              is_attachment3: "false",
              is_attachment4: "false",
              is_attachment: hasAnyAttachment ? "Y" : "N",
            });

            this.value = editData.body || "";
            if (this.rteInstance) {
              this.rteInstance.value = this.value; // Sync RichTextEditor
            }

            this.templateId = editData.template_id || "";

            this.modalTitle = " Edit Email ";
          }
          this.loadHide();
        },
        (error) => {
          this.loadHide();
        },
      );
  }

  setupVariableDropdownListener() {
    const dropdown = document.getElementById(
      "variablesDropdown",
    ) as HTMLSelectElement;
    if (dropdown) {
      dropdown.addEventListener("change", (event: Event) => {
        const variable = (event.target as HTMLSelectElement).value;
        if (variable) {
          this.insertVariableAtCursor(variable);
          (event.target as HTMLSelectElement).value = "";
        }
      });
    } else {
      console.error("variablesDropdown not found in DOM");
    }
  }

  ngAfterViewInit() {
    this.setupVariableDropdownListenerWithRetry();
    this.dtTrigger.next();
  }

  setupVariableDropdownListenerWithRetry(attempts = 5, delay = 500) {
    const tryAttach = (attempt: number) => {
      const dropdown = document.getElementById(
        "variablesDropdown",
      ) as HTMLSelectElement;
      if (dropdown && this.rteInstance) {
        dropdown.addEventListener("change", (event: Event) => {
          const variable = (event.target as HTMLSelectElement).value;
          if (variable) {
            this.insertVariableAtCursor(variable);
            (event.target as HTMLSelectElement).value = ""; // Reset dropdown
          }
        });
      } else if (attempt > 0) {
        setTimeout(() => tryAttach(attempt - 1), delay);
      } else {
        console.error(
          "Failed to find variablesDropdown or RichTextEditor instance after retries",
        );
      }
    };
    tryAttach(attempts);
  }

  insertVariableAtCursor(variable: string) {
    if (this.rteInstance) {
      this.rteInstance.focusIn();
      this.rteInstance.executeCommand("insertHTML", variable);
      this.value = this.rteInstance.getHtml();
      this.TempMailForm.patchValue({ body: this.value });
    } else {
      console.error(
        "RichTextEditor instance is not available. Ensure the editor is rendered.",
      );
    }
  }

  onSendMail() {
    this.EditId = "";
    this.TempMailForm.reset();
    setTimeout(() => {
      this.sendMailSection.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }

  open(content) {
    this.currentAttachment1 = {
      fileName: "",
      type: "",
      base64: "",
    };

    this.currentAttachment2 = {
      fileName: "",
      type: "",
      base64: "",
    };

    this.currentAttachment3 = {
      fileName: "",
      type: "",
      base64: "",
    };

    this.currentAttachment4 = {
      fileName: "",
      type: "",
      base64: "",
    };

    this.isSuccessShow = "";
    this.isErrorShow = "";

    this.EditId = "";
    this.selectedFileName = "";
    this.isEditExcel = "";
    this.TempMailForm.reset({
      title: "",
      subject: "",
      body: "",
      templates: "",
      specificEmails: "",
      schedule_type: "now",
      schedule_date: "",
      schedule_time: "",
      mentee_type: false,
      mentor_type: false,
      partner_type: false,
      mentee_to_all: false,
      mentor_to_all: false,
      partner_to_all: false,
      isTestEmailMode: false,
      test_email: "",
      mentee_business_type: "ALL",
      is_attachment: "N",
      attachment_delete_1: false,
      attachment_delete_2: false,
      attachment_delete_3: false,
      attachment_delete_4: false,
    });
    this.isSubmitted = false;
    this.modalTitle = "Add Email";

    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
    this.value = "";
    if (this.rteInstance) {
      this.rteInstance.value = "";
    }
  }

  getApiPayload() {
    const formValue = this.TempMailForm.getRawValue();
    const payload = {
      ...formValue,
      mentee_type: this.getRecipientTypeValue(
        formValue.mentee_type,
        formValue.mentee_to_all,
      ),
      mentor_type: this.getRecipientTypeValue(
        formValue.mentor_type,
        formValue.mentor_to_all,
      ),
      partner_type: this.getRecipientTypeValue(
        formValue.partner_type,
        formValue.partner_to_all,
      ),
    };

    if (formValue.schedule_type === "schedule" && !formValue.isTestEmailMode) {
      if (formValue.schedule_date && formValue.schedule_time) {
        payload.schedule_datetime = `${formValue.schedule_date} ${formValue.schedule_time}:00`;
      } else {
        payload.schedule_datetime = null;
      }
      delete payload.schedule_date;
      delete payload.schedule_time;
    } else {
      delete payload.schedule_date;
      delete payload.schedule_time;
      payload.schedule_datetime = null;
    }

    return payload;
  }

  private extractTime(datetime: string | null | undefined): string | null {
    if (!datetime) return null;
    const parts = datetime.split(" ");
    if (parts.length < 2) return null;
    return parts[1].substring(0, 5) || null;
  }

  private getRecipientTypeValue(type: boolean, toAll: boolean): string {
    if (!type) {
      return "none";
    }
    return toAll ? "verified" : "all";
  }

  onMenteeChange() {
    if (!this.menteeChecked) {
      this.menteeToAll = false;
    }
  }

  delete(item) {
    const index = this.emailServiceListing.findIndex((i) => i.id == item.id);
    if (index !== -1) {
      this.emailServiceListing[index].isRefreshing = true;
      this.updateRowSpinner(item.id, true);
    }

    this.loadShow();
    const res = { id: item.id };
    this.service.onDeleteMail(res).subscribe(
      (data) => {
        if (data && data["status"] === 200 && data["data"]) {
          const updatedRowData = data["data"];
          const index = this.emailServiceListing.findIndex(
            (i) => i.id == item.id,
          );
          if (index !== -1) {
            this.emailServiceListing[index] = {
              id: updatedRowData.id,
              title: updatedRowData.title || "",
              subject: updatedRowData.subject || "",
              template_name: updatedRowData.template_name || "",
              schedule_date: updatedRowData.schedule_date || "",
              schedule_by: updatedRowData.schedule_by || "",
              mentee_count: updatedRowData.mentee_count || 0,
              mentor_count: updatedRowData.mentor_count || 0,
              partner_count: updatedRowData.partner_count || 0,
              total_count: updatedRowData.total_count || 0,
              pending_and_inprogress_count:
                updatedRowData.pending_and_inprogress_count || 0,
              success_count: updatedRowData.success_count || 0,
              invalid_email_and_error_count:
                updatedRowData.invalid_email_and_error_count || 0,
              stopped_count: updatedRowData.stopped_count || 0,
              status: updatedRowData.status || "0",
              parent_route: updatedRowData.parent_route || "",
            };

            this.updateDataTableRow(item.id, updatedRowData);
            this.alertService.success(
              "Email Template deleted successfully",
              true,
            );
          } else {
            this.reloadDataTable();
            this.alertService.success(
              "Email Template deleted, table reloaded",
              true,
            );
          }
        } else {
          this.alertService.error("Failed to delete email template");
        }
        if (index !== -1) {
          this.emailServiceListing[index].isRefreshing = false;
          this.updateRowSpinner(item.id, false);
        }
        this.loadHide();
      },
      (error) => {
        this.alertService.error("Failed to delete email template");
        if (index !== -1) {
          this.emailServiceListing[index].isRefreshing = false;
          this.updateRowSpinner(item.id, false);
        }
        this.loadHide();
      },
    );
  }

  onMentorChange() {
    if (!this.mentorChecked) {
      this.mentorToAll = false;
    }
  }

  onPartnerChange() {
    if (!this.partnerChecked) {
      this.partnerToAll = false;
    }
  }

  atLeastOneRecipientValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const specificEmails = formGroup.get("specificEmails").value;
      const mentee = formGroup.get("mentee").value;
      const mentor = formGroup.get("mentor").value;
      const partner = formGroup.get("partner").value;

      const hasSpecificEmails =
        specificEmails && specificEmails.trim().length > 0;
      const hasCheckboxSelected = mentee || mentor || partner;

      if (hasSpecificEmails || hasCheckboxSelected) {
        return null;
      }

      return {
        noRecipient: true,
        missingSpecificEmails: !hasSpecificEmails,
        missingCheckboxes: !hasCheckboxSelected,
      };
    };
  }
  toggleMain(role: string, event: any) {
    if (!event.target.checked) {
      this.TempMailForm.get(`${role}_type`).setValue("none");
    }
  }

  setType(role: string, type: "all" | "verified", event: any) {
    if (event.target.checked) {
      this.TempMailForm.get(`${role}_type`).setValue(type);
    } else {
      this.TempMailForm.get(`${role}_type`).setValue("none");
    }
  }

  isMainChecked(role: string): boolean {
    return this.TempMailForm.get(`${role}_type`).value !== "none";
  }

  isChecked(role: string, type: "all" | "verified"): boolean {
    return this.TempMailForm.get(`${role}_type`).value === type;
  }

  getValues() {
    alert(JSON.stringify(this.TempMailForm.value, null, 2));
  }

  getTemplateMaster() {
    const data = {};
    this.service.onTemplateMaster(data).subscribe((res: any) => {
      if (res["status"] == 200) {
        this.templates = res["data"];
      }
    });
  }

  onTemplateSelect(event: any) {
    const selectedIndex = event.target.value;

    if (selectedIndex !== "") {
      const selectedTemplate = this.templates[selectedIndex];
      this.templateId = selectedTemplate.id;
      this.value = selectedTemplate.body;
      this.TempMailForm.patchValue({
        body: selectedTemplate.body,
      });
    }
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.TempMailForm.get(fieldName);
    return !!(field && field.invalid && (field.touched || this.isSubmitted));
  }

  isInvalid(field_name: string): boolean {
    const field = this.TestEmailForm.get(field_name);
    return !!(
      field &&
      field.invalid &&
      (field.touched || this.isTestEmailSubmitted)
    );
  }

  getEditorValue(): string | null {
    let $editor = $(".e-richtexteditor") as any;
    let editorInstance = $editor[0].ej2_instances[0];

    if (editorInstance) {
      const htmlContent = editorInstance.value;

      return htmlContent;
    } else {
      return null;
    }
  }

  onSubmit() {
    const val = this.getEditorValue();
    this.TempMailForm.patchValue({ body: val });
    this.isSubmitted = true;
    this.loadShow();
    this.validateAttachments();
    if (this.TempMailForm.valid && val.trim() !== "") {
      
      const formData: FormData = new FormData();
      const payload = this.getApiPayload();

      formData.append("subject", this.TempMailForm.value.subject || "");
      formData.append("body", this.TempMailForm.value.body || "");
      formData.append("title", this.TempMailForm.value.title || "");
      formData.append("template_id", this.templateId || "");
      const draft = this.TempMailForm.value.is_published
        ? "DRAFT"
        : "PUBLISHED";
      formData.append("is_published", draft);
      formData.append("is_excel", this.TempMailForm.value.is_excel || "");
      formData.append(
        "is_attachment",
        this.TempMailForm.value.is_attachment || "",
      );

       const attachments = [
          this.currentAttachment1,
          this.currentAttachment2,
          this.currentAttachment3,
          this.currentAttachment4,
        ];
        attachments.forEach((attachment, i) => {
          const index = i + 1;
          const isDelete =
            this.TempMailForm.get(`attachment_delete_${index}`).value === true;

          const isNewBase64 =
            typeof attachment.base64 === "string" &&
            attachment.base64.startsWith("data:");

          formData.append(
            `attachment_path_${index}`,
            isNewBase64 ? attachment.base64 : "",
          );

          formData.append(
            `attachment_type_${index}`,
            isNewBase64 ? attachment.type || "" : "",
          );

          formData.append(`attachment_delete_${index}`, isDelete ? "Y" : "N");
        });

      if (this.TempMailForm.value.isTestEmailMode) {
        const testEmails = this.TempMailForm.value.test_email
          ? this.TempMailForm.value.test_email
              .split(",")
              .map((e: string) => e.trim())
              .filter((e: string) => e !== "")
          : [];

        formData.append(
          "test_email",
          testEmails.length > 0 ? testEmails.join(",") : "",
        );
        this.service.onTestEmail(formData).subscribe({
          next: (res: any) => {
            if (res["status"] == 200) {
              this.loadHide();
              this.isSuccessShow = "Test Email has been sent successfully";
              setTimeout(() => (this.isSuccessShow = ""), 5000);
            } else if (res["status"] == 422) {
              this.loadHide();
              this.isErrorShow = res["mesg"];
              setTimeout(() => (this.isErrorShow = ""), 5000);
            }
          },
          error: (err) => {
            this.loadHide();
            this.isErrorShow = "Failed to send test email";
            setTimeout(() => (this.isErrorShow = ""), 5000);
          },
        });
      } else {
        formData.append("mentee_type", payload.mentee_type || "");
        if (payload.mentee_type != "none") {
          formData.append(
            "mentee_business_type",
            this.TempMailForm.value.mentee_business_type || "",
          );
        }
        formData.append("mentor_type", payload.mentor_type || "");
        formData.append("partner_type", payload.partner_type || "");
        formData.append(
          "schedule_type",
          this.TempMailForm.value.schedule_type || "",
        );
        formData.append("schedule_date", payload.schedule_datetime || "");

        const specificEmails = this.TempMailForm.value.specificEmails
          ? this.TempMailForm.value.specificEmails
              .split(",")
              .map((e: string) => e.trim())
              .filter((e: string) => e !== "")
          : [];

        formData.append(
          "specific_emails",
          specificEmails.length > 0 ? specificEmails.join(",") : "",
        );

        if (this.EditId == "") {
          formData.append("excel", this.excelUrl || "");
          this.service.newMassEmail(formData).subscribe({
            next: (res: any) => {
              if (res["status"] === 200) {
                this.loadHide();
                this.isSuccessShow = "Email has been sent successfully";
                setTimeout(() => (this.isSuccessShow = ""), 5000);
                this.TempMailForm.reset();
                this.TempMailForm.patchValue({ templates: "" });
                this.value = "";
                this.isSubmitted = false;

                if (this.rteInstance) {
                  this.rteInstance.value = "";
                }
                this.modalReference.close();

                const table = $("#emailServiceTable").DataTable();
                table.ajax.reload(null, false);
              } else if (res["status"] === 422) {
                if (res["mesg"]) {
                  this.loadHide();
                  this.isErrorShow = res["mesg"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                } else if (res["errors"]["specific_emails"]) {
                  this.loadHide();
                  this.isErrorShow = res["errors"]["specific_emails"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                }
              } else if (res["status"] === 322) {
                if (res["email_errors"]["validationErrors"]) {
                  this.loadHide();
                  this.isErrorShow = res["email_errors"]["validationErrors"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                }
              } else {
                this.loadHide();
                this.isErrorShow = "Failed to send email";
                setTimeout(() => (this.isErrorShow = ""), 5000);
              }
            },
            error: (err) => {
              this.loadHide();
              this.isErrorShow = "Failed to send email";
              setTimeout(() => (this.isErrorShow = ""), 5000);
            },
          });
        } else {
          formData.append("id", this.EditId);
          if (this.excelUrl && this.excelUrl.startsWith("data:")) {
            formData.append("excel", this.excelUrl);
          } else {
            formData.append("excel", "");
          }
          this.service.onUpdateEmail(formData).subscribe({
            next: (res: any) => {
              if (res["status"] === 200) {
                this.loadHide();
                this.isSuccessShow = "Email has been sent successfully";
                setTimeout(() => (this.isSuccessShow = ""), 5000);
                this.TempMailForm.reset();
                this.TempMailForm.patchValue({ templates: "" });
                this.value = "";
                this.isSubmitted = false;

                if (this.rteInstance) {
                  this.rteInstance.value = "";
                }
                this.modalReference.close();

                const table = $("#emailServiceTable").DataTable();
                table.ajax.reload(null, false);
              } else if (res["status"] === 422) {
                if (res["mesg"]) {
                  this.loadHide();
                  this.isErrorShow = res["mesg"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                } else if (res["errors"]["specific_emails"]) {
                  this.loadHide();
                  this.isErrorShow = res["errors"]["specific_emails"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                }
              } else if (res["status"] === 322) {
                if (res["email_errors"]["validationErrors"]) {
                  this.loadHide();
                  this.isErrorShow = res["email_errors"]["validationErrors"];
                  setTimeout(() => (this.isErrorShow = ""), 5000);
                }
              } else {
                this.loadHide();
                this.isErrorShow = "Failed to send email";
                setTimeout(() => (this.isErrorShow = ""), 5000);
              }
            },
            error: (err) => {
              this.loadHide();
              this.isErrorShow = "Failed to send email";
              setTimeout(() => (this.isErrorShow = ""), 5000);
            },
          });
        }
      }
    } else {
      this.TempMailForm.markAllAsTouched();
      this.loadHide();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

private hasValidAttachment(attachment: any): boolean {
  if (!attachment) return false;

  if (typeof attachment.base64 === 'string') {
    if (attachment.base64.startsWith('http://') || attachment.base64.startsWith('https://')) {
      return true;
    }
    
    if (attachment.base64.startsWith('data:')) {
      return true;
    }
  }

  return false;
}

private validateAttachments(): void {
  const isAttachmentEnabled = this.TempMailForm.get('is_attachment').value === 'Y';

  if (!isAttachmentEnabled) {
    this.TempMailForm.setErrors(null);
    return;
  }

  const attachments = [
    this.currentAttachment1,
    this.currentAttachment2,
    this.currentAttachment3,
    this.currentAttachment4
  ];

  const hasAtLeastOneValid = attachments.some(att => this.hasValidAttachment(att));

  const delete1 = this.TempMailForm.get('attachment_delete_1').value === true;
  const delete2 = this.TempMailForm.get('attachment_delete_2').value === true;
  const delete3 = this.TempMailForm.get('attachment_delete_3').value === true;
  const delete4 = this.TempMailForm.get('attachment_delete_4').value === true;

  if (delete1 && delete2 && delete3 && delete4 && !hasAtLeastOneValid) {
    this.TempMailForm.setErrors({ attachmentRequired: true });
    return;
  }

  if (hasAtLeastOneValid) {
    this.TempMailForm.setErrors(null);
  } else {
    this.TempMailForm.setErrors({ attachmentRequired: true });
  }
}
  attachmentRequiredValidator(form: FormGroup): ValidationErrors | null {
    const isAttachment = form.get("is_attachment").value === "Y";

    if (!isAttachment) {
      return null; 
    }

    const attachments = [
      this.currentAttachment1,
      this.currentAttachment2,
      this.currentAttachment3,
      this.currentAttachment4,
    ];

    const hasAtLeastOneAttachment = attachments.some(
      (att) =>
        att &&
        att.base64 &&
        att.base64.trim() !== "" &&
        att.base64.startsWith("data:"),
    );

    if (!hasAtLeastOneAttachment) {
      return { attachmentRequired: true };
    }

    return null;
  }

  onExcelChange(event: any) {
    const value = event.target.checked ? "Y" : "N";
    this.TempMailForm.get("is_excel").setValue(value);
  }

  onAttachmentChange(event: any) {
    const value = event.target.checked ? "Y" : "N";
    this.TempMailForm.get("is_attachment").setValue(value);
  }

  onRefresh(id: any) {
    const index = this.emailServiceListing.findIndex((item) => item.id == id);
    if (index !== -1) {
      this.emailServiceListing[index].isRefreshing = true; 
      this.updateRowSpinner(id, true); 
      this.cdr.detectChanges(); 
    } else {
      this.alertService.error("Row not found in current view", true);
      return;
    }

    const data = { id: id };
    this.service.onRefreshEmail(data).subscribe({
      next: (res: any) => {
        if (res && res["status"] === 200 && res["data"]) {
          const updatedRowData = res["data"];
          this.emailServiceListing[index] = {
            id: updatedRowData.id,
            title: updatedRowData.title || "",
            subject: updatedRowData.subject || "",
            template_name: updatedRowData.template_name || "",
            schedule_date: updatedRowData.schedule_date || "",
            schedule_by: updatedRowData.schedule_by || "",
            mentee_count: updatedRowData.mentee_count || 0,
            mentor_count: updatedRowData.mentor_count || 0,
            partner_count: updatedRowData.partner_count || 0,
            excel_count: updatedRowData.excel_count || 0,
            total_count: updatedRowData.total_count || 0,
            pending_and_inprogress_count:
              updatedRowData.pending_and_inprogress_count || 0,
            success_count: updatedRowData.success_count || 0,
            invalid_email_and_error_count:
              updatedRowData.invalid_email_and_error_count || 0,
            stopped_count: updatedRowData.stopped_count || 0,
            status: updatedRowData.status || "0",
            parent_route: updatedRowData.parent_route || "",
            isRefreshing: false,
          };
          this.updateDataTableRow(id, this.emailServiceListing[index]);
          this.alertService.success("Row refreshed successfully", true);
        } else {
          this.alertService.error("Failed to refresh row: Invalid response");
        }
        this.emailServiceListing[index].isRefreshing = false;
        this.updateRowSpinner(id, false);
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.alertService.error("Failed to refresh row");
        if (index !== -1) {
          this.emailServiceListing[index].isRefreshing = false;
          this.updateRowSpinner(id, false);
          this.cdr.detectChanges();
        }
      },
    });
  }

  updateDataTableRow(id: any, updatedRow: any) {
    const table = ($("#emailServiceTable") as any).DataTable();
    const row = table.row((idx: number, data: any, node: any) => {
      return data[1].toString().startsWith(id.toString());
    });

    if (row.node()) {
      row
        .data([
          updatedRow.id + "-" + updatedRow.parent_route,
          updatedRow.title,
          updatedRow.subject,
          updatedRow.template_name,
          this.formatDateTime(updatedRow.schedule_date),
          updatedRow.schedule_by,
          updatedRow.mentee_count,
          updatedRow.mentor_count,
          updatedRow.partner_count,
          updatedRow.total_count,
          updatedRow.pending_and_inprogress_count,
          updatedRow.success_count,
          updatedRow.invalid_email_and_error_count,
          updatedRow.stopped_count,
          updatedRow.status === "1"
            ? `<span class="badge badge-success">Active</span>`
            : `<span class="badge badge-danger">Inactive</span>`,
        ])
        .draw(false);
    }
  }

  private updateRowSpinner(id: any, show: boolean) {
    const $row = $(
      `#emailServiceTable tbody tr td button[data-id="${id}"]`,
    ).closest("tr");
    const $refreshButton = $row.find(
      `button i.fa-refresh, button i.fa-spinner`,
    );
    if (show) {
      $refreshButton.removeClass("fa-refresh").addClass("fa-spinner fa-spin");
      $row.find("button, input").prop("disabled", true);
    } else {
      $refreshButton.removeClass("fa-spinner fa-spin").addClass("fa-refresh");
      $row.find("button, input").prop("disabled", false);
    }
  }

  reloadDataTable() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(null, false);
    });
  }

  multipleEmailValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;

    const emails = control.value
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e !== "");

    if (emails.length > 100) {
      return { tooManyEmails: true };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    return invalidEmails.length > 0 ? { invalidEmails } : null;
  }

  exportToExcel() {
    const data = {
      export: true,
    };
    this.service.exportEmail(data).subscribe((res: any) => {
      if (res["status"] == 200) {
        this.exportEmailerList = res.data.map((item: any) => {
          return {
            ...item,
            mailer_id: `${item.id}-${item.parent_route}`,
          };
        });

        this.fieldsToIncludeExcel = [
          "mailer_id",
          "title",
          "subject",
          "template_name",
          "schedule_date",
          "schedule_by",
          "mentee_count",
          "mentor_count",
          "partner_count",
          "total_count",
          "pending_and_inprogress_count",
          "success_count",
          "invalid_email_and_error_count",
          "stopped_count",
          "excel_count",
        ];

        this.excelService.generateExcel(
          this.exportEmailerList,
          this.fieldsToIncludeExcel,
          "Emailer",
        );
        this.exl = true;
        this.loadHide();
      }
    });
  }

  onTestEmailSend() {
    this.isTestEmailSubmitted = true;
  }
  onMainToggleChange(selectedIndex: number) {
    this.recipients.forEach((rec, i) => {
      if (i === selectedIndex) {
        rec.mainToggle = !rec.mainToggle;
        rec.toAllEnabled = rec.mainToggle;
        rec.toAllToggle = false; // reset
      } else {
        rec.mainToggle = false;
        rec.toAllEnabled = false;
        rec.toAllToggle = false;
      }
    });
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }
}
